import { render, staticRenderFns } from "./TpvResponse.vue?vue&type=template&id=38f809fc&scoped=true&"
import script from "./TpvResponse.vue?vue&type=script&lang=js&"
export * from "./TpvResponse.vue?vue&type=script&lang=js&"
import style0 from "./TpvResponse.vue?vue&type=style&index=0&id=38f809fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f809fc",
  null
  
)

export default component.exports